import { ITEMS_COUNT } from 'actions/itemsCount'

export default (state = 0, action) => {
    switch (action.type) {
        case ITEMS_COUNT:
            if (!!action.error) {
                return action.payload;
            } else {
                return action.payload.data.count;
            }
    }

    return state;
}